export enum DialogShowMode {
  Default,
  Side,
  AppNavDrawer,
}
